export default __webpack_public_path__ + "static/workshop-f6f3d49177eacc24dff9b24287d2c882.png";